export default function Hero() {
  return (
    <section className="relative w-full h-[500px] md:h-[650px] flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20product%20photography%20collage%20featuring%20a%20diverse%20arrangement%20of%20modern%20clothing%20footwear%20and%20accessories%20floating%20in%20a%20dreamy%20floating%20composition%2C%20items%20include%20sneakers%20a%20leather%20tote%20bag%20folded%20hoodie%20baseball%20cap%20sunglasses%20and%20a%20perfume%20bottle%2C%20soft%20pastel%20peach%20and%20sage%20green%20background%20with%20abstract%20geometric%20shapes%2C%20gentle%20ethereal%20lighting%20with%20subtle%20glow%20effects%2C%20whimsical%20editorial%20aesthetic%2C%20harmonious%20balanced%20arrangement%2C%20clean%20modern%20minimal%20style%20with%20creative%20negative%20space&width=1800&height=1300&seq=hero-bg-v2&orientation=landscape"
          alt="OOPBuy Spreadsheet fashion product showcase"
          title="OOPBuy Spreadsheet product collection"
          className="w-full h-full object-cover object-top"
        />
        {/* Gradient overlay for text readability */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/25 to-black/50"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full px-6 md:px-14 lg:px-20">
        <div className="max-w-2xl">
          {/* Tag */}
          <span className="inline-block px-4 py-1.5 border border-white/40 rounded-full text-xs md:text-sm text-white/90 font-medium tracking-wide mb-5 md:mb-7">
            SEO Optimized Product Hub
          </span>

          {/* Title */}
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-3">
            The Ultimate
          </h1>
          <h2 className="font-heading text-4xl md:text-6xl lg:text-7xl font-light text-white leading-tight mb-7 md:mb-9">
            OOPBuy Spreadsheet System
          </h2>

          {/* Description */}
          <p className="text-white/75 text-sm md:text-base max-w-md mb-8 md:mb-10 leading-relaxed">
            Your complete ecommerce order tracking and automation hub. Browse product categories, explore spreadsheet guides, and streamline your selling workflow.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 bg-primary-500 text-background-50 font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              oopbuy spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-7 py-3 bg-white/15 backdrop-blur-sm text-white font-semibold text-sm rounded-md border border-white/30 hover:bg-white/25 transition-colors text-center whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-6 h-10 border-2 border-white/40 rounded-full flex items-start justify-center p-1.5">
          <div className="w-1 h-2.5 bg-white/60 rounded-full animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}